(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ContratChangeStatusDialogController', ContratChangeStatusDialogController);

    ContratChangeStatusDialogController.$inject = ['$scope', '$uibModalInstance', 'entity', 'Contrat', 'ClosingContractReason'];

    function ContratChangeStatusDialogController($scope, $uibModalInstance, entity, Contrat, ClosingContractReason) {
        var vm = this;
        vm.contrat = null;
        vm.isLoading = true;
        vm.statusOptions = ['ACTIVE', 'DORMANT', 'FIRST_REMINDER', 'SECOND_REMINDER', 'LITIGATION'];
        vm.request = {
            contratId: null,
            newStatus: null,
            generateRecoveryNotice: false,
            createTicket: false,
            closingContractReasonId: null
        };
        vm.closingContractReasons = ClosingContractReason.query();
        vm.save = save;
        vm.clear = clear;
        resolveEntity(entity);

        vm.isReminderStatus = function() {
            return vm.request.newStatus === 'FIRST_REMINDER' || vm.request.newStatus === 'SECOND_REMINDER';
        };

        vm.isTicketEligibleStatus = function() {
            return vm.request.newStatus === 'LITIGATION' || vm.request.newStatus === 'CLOSED';
        };

        vm.isClosedStatus = function() {
            return vm.request.newStatus === 'CLOSED';
        };

        $scope.$watch(function() {
            return vm.request.newStatus;
        }, function(newValue) {
            if (newValue !== 'FIRST_REMINDER' && newValue !== 'SECOND_REMINDER') {
                vm.request.generateRecoveryNotice = false;
            }
            if (newValue !== 'LITIGATION' && newValue !== 'CLOSED') {
                vm.request.createTicket = false;
            }
            if (newValue !== 'CLOSED') {
                vm.request.closingContractReasonId = null;
            }
        });

        function save() {
            if (!vm.request.contratId) {
                return;
            }
            vm.isSaving = true;
            Contrat.changeStatus(vm.request, function(result) {
                $scope.$emit('wamasysApp:contratUpdate', result);
                vm.isSaving = false;
                $uibModalInstance.close(result);
            }, function() {
                vm.isSaving = false;
            });
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function resolveEntity(loadedEntity) {
            if (loadedEntity && loadedEntity.$promise && angular.isFunction(loadedEntity.$promise.then)) {
                loadedEntity.$promise.then(applyEntity, function() {
                    vm.isLoading = false;
                });
                return;
            }
            applyEntity(loadedEntity);
        }

        function applyEntity(loadedEntity) {
            vm.contrat = loadedEntity || {};
            vm.request.contratId = vm.contrat.id || null;
            vm.request.newStatus = vm.contrat.etat || null;
            vm.request.closingContractReasonId = vm.contrat.closingContractReason ? vm.contrat.closingContractReason.id : null;
            vm.isLoading = false;
        }
    }
})();
